import React from 'react';

import SingleColumnTemplate from '@/components/layouts/SingleColumnTemplate';
import Jumbotron from '@/components/ui/box/Jumbotron';
import Panel from '@/components/ui/box/Panel';
import Paper from '@/components/ui/box/Paper';
import { pageTitles } from '@/constants/pageTitles';
import AccountRegistrationForm from '@/features/registration/components/AccountRegistrationForm';
import {
  type AccountRegistrationFormValues,
  type StudentInfo,
} from '@/interfaces/registration';

import CSSModule from './AccountRegistrationPage.module.scss';

interface Props {
  formValues: AccountRegistrationFormValues;
  onSubmit: (
    formValues: AccountRegistrationFormValues,
    studentInfo: StudentInfo,
  ) => void;
}

const AccountRegistrationPage: React.FC<Props> = ({ formValues, onSubmit }) => (
  <SingleColumnTemplate>
    <div className={CSSModule.AccountRegistrationPage}>
      <Jumbotron>
        <Paper>
          <Panel title={pageTitles.accountRegistration} strongHeader>
            <div className={CSSModule.Panel__Description}>
              メールアドレスとパスワードは、ログインする時に必要になります。
              {'\n'}
              お手元に控えてください。
            </div>
            <AccountRegistrationForm
              formValues={formValues}
              onSubmit={onSubmit}
            />
          </Panel>
        </Paper>
      </Jumbotron>
    </div>
  </SingleColumnTemplate>
);

export default AccountRegistrationPage;
